<script setup lang="ts">
import { ReactiveFile } from "~/classes/file/ReactiveFile"

const props = defineProps({
  file: null,
  loading: { type: Boolean },
  error: null
})

const { file } = toRefs(props)
const reactiveFile = new ReactiveFile({ file, location: "agent" })

const createContainer = useTemplateRef("createContainer")
const { width: containerWidth } = useElementSize(createContainer)
const containerHeight = computed(() => {
  const width = reactiveFile.mediaWidthPx()
  const height = reactiveFile.mediaHeightPx()
  if (!width || !height)
    return containerWidth.value
  return (containerWidth.value * height) / width
})

const didDownload = computed(() => isDefined(reactiveFile.downloadSourceApplication()))
const hasThumbnail = computed(() => !props.loading && isDefined(reactiveFile.thumbnailSet()))
const label = computed(() => {
  if (didDownload.value)
    return "Downloaded image"
  return "Generated image"
})
</script>

<template>
  <agent-status-preview
    ref="createContainer"
    :file
    :loading="!hasThumbnail"
    :error
    :label
    class="image-preview"
  >
    <div class="image-container">
      <div class="header">
        <div class="file-name">
          {{ reactiveFile.name() }}
        </div>
      </div>
      <div v-if="hasThumbnail" class="agent-preview-thumbnail">
        <file-thumbnail
          :file="reactiveFile.asStatic()"
          :container-width
          :container-height
          hide-stale
        />
      </div>
    </div>
  </agent-status-preview>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.image-container
  @apply min-h-[26px] flex flex-col w-full h-full
  @apply shadow-card bg-[#07060866]
  @apply outline outline-0.75 outline-[#55575F40]
  @apply relative
  @apply flex flex-col gap-1
  @apply rounded-[6px]

.header
  @apply absolute left-0 top-0 w-full p-2 z-1
  @apply h-[26px] flex-none flex items-center gap-1 w-full overflow-hidden

.file-name
  @apply t-menu-sm text-ellipses-inline min-w-0

.collapse
  @apply ml-auto rounded-[4px] cursor-pointer
  &:hover
    @apply bg-[#{$menu-bg-item-hover}]

.agent-preview-thumbnail
  @apply rounded-[6px] overflow-hidden z-0
</style>
